import {
    cleanCommonParams,
    mapImageParams,
    mapAttachmentParams,
    mapSalesChannelsParams,
} from './common';

const mapCollateralDigitalAssetParams = (
    isCreate,
    {
        image,
        attachment,
        // eslint-disable-next-line camelcase
        sales_channels,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_digital_asset: {
                ...cleanCommonParams(params),
                ...mapImageParams(isCreate, image),
                ...mapAttachmentParams(isCreate, attachment),
                ...mapSalesChannelsParams(isCreate, sales_channels),
            },
        });
    });
};

export { mapCollateralDigitalAssetParams };
